import { Loader } from '@gurupay/gp-ui-library';
import { useTemplateWithAccount } from '@hooks/useTemplateWithAccount';
import { nullsToUndefined, prepareTemplateForPayment } from '@utils/utils';
import React from 'react';
import { useSearchParams } from 'react-router-dom';
import type { CreatePaymentTemplate } from 'types/templates';

export const TemplateLoader = ({ children }: { children: React.ReactNode }) => {
	const [search] = useSearchParams();
	const templateId = search.get('templateId');
	const { template, isLoading, selectedAccount } = useTemplateWithAccount(
		templateId ?? undefined,
	);

	if (isLoading) {
		return (
			<div className="flex items-center justify-center h-[500px]">
				<Loader />
			</div>
		);
	}

	return (
		<>
			{React.Children.map(children, (child) =>
				React.isValidElement(child)
					? React.cloneElement(child as React.ReactElement<any>, {
							template: template
								? prepareTemplateForPayment(
										nullsToUndefined(template) as CreatePaymentTemplate,
									)
								: null,
							selectedAccount,
						})
					: child,
			)}
		</>
	);
};
